import moment from 'moment';

export const getLocalDateTime = (dateTimeString: string) => {
    return moment(dateTimeString).utcOffset(0, false).format('MM/DD/YYYY HH:mm:ss');
};
